import React, { useState } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function DisclaimerModal() {
  const { refreshUser } = useAuth();
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    if (!checked || loading) return;
    setLoading(true);
    try {
      await api.post('/user/accept-disclaimer');
      await refreshUser();
    } catch (err) {
      console.error('Failed to accept disclaimer:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.overlay}>
      <div style={s.modal}>

        {/* Header */}
        <div style={s.header}>
          <div style={s.headerBrand}>
            <img src="/Ask Nitin Icon V1.png" alt="Ask Nitin" style={s.headerLogo} onError={e => { e.target.style.display = 'none'; }} />
            <div>
              <div style={s.headerTitle}>Ask Nitin</div>
              <div style={s.headerSub}>Personal Mentor for Law Students</div>
            </div>
          </div>
        </div>

        {/* Scrollable body */}
        <div style={s.body}>

          <p style={s.noteTitle}>A Note Before You Begin</p>
          <p style={s.noteText}>
            Everything on Ask Nitin is insight notes and mentorship conversation, not formal legal or professional career advice. The answers and guidance here are based on my personal experience of over 30 years in corporate law and my observations from mentoring hundreds of students and young lawyers. They are offered in the same spirit as a trusted senior colleague speaking honestly across a table.
          </p>
          <p style={s.noteText}>
            Please treat them as guidance notes. For specific legal matters or career decisions of significant consequence, you need to consult a certified career counsellor directly.
          </p>
          <p style={s.noteText}>
            My only goal here is to give you the honest, practical guidance I wish someone had given me when I was starting out.
          </p>
          <p style={s.signature}>Nitin Potdar · Mumbai, India · March 2026</p>
        </div>

        {/* Footer - confirmation */}
        <div style={s.footer}>
          <label style={s.checkLabel} onClick={() => setChecked(v => !v)}>
            <div style={{ ...s.checkbox, ...(checked ? s.checkboxChecked : {}) }}>
              {checked && (
                <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
                  <polyline points="2,6 5,9 10,3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </div>
            <span style={s.checkText}>
              I have read and accept the above. I understand that Ask Nitin provides mentorship guidance and not formal legal or career advice.
            </span>
          </label>

          <button
            onClick={handleAccept}
            disabled={!checked || loading}
            style={{ ...s.acceptBtn, opacity: !checked || loading ? 0.5 : 1, cursor: !checked || loading ? 'not-allowed' : 'pointer' }}
          >
            {loading ? (
              <span style={s.spinner} />
            ) : 'Accept & Continue'}
          </button>
        </div>
      </div>
    </div>
  );
}

const s = {
  overlay: {
    position: 'fixed', inset: 0, zIndex: 9999,
    background: 'rgba(12,35,64,0.7)',
    backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '16px', boxSizing: 'border-box',
  },
  modal: {
    background: '#fff', borderRadius: '20px',
    boxShadow: '0 24px 80px rgba(12,35,64,0.3)',
    width: '100%', maxWidth: '620px',
    maxHeight: '90vh', display: 'flex', flexDirection: 'column',
    overflow: 'hidden',
  },
  header: {
    background: 'var(--navy)', padding: '18px 24px', flexShrink: 0,
  },
  headerBrand: { display: 'flex', alignItems: 'center', gap: '12px' },
  headerLogo: { width: '36px', height: '36px', borderRadius: '8px', objectFit: 'contain' },
  headerTitle: {
    fontFamily: "'Playfair Display', Georgia, serif",
    fontSize: '17px', fontWeight: '700', color: '#fff',
  },
  headerSub: { fontSize: '11px', color: 'rgba(255,255,255,0.55)', marginTop: '1px' },
  body: {
    flex: 1, overflowY: 'auto', padding: '24px 28px',
    display: 'flex', flexDirection: 'column', gap: '12px',
  },
  welcome: {
    fontFamily: "'Playfair Display', Georgia, serif",
    fontSize: '20px', fontWeight: '700', color: 'var(--navy)', margin: 0,
  },
  intro: { fontSize: '14px', color: 'var(--text-2)', lineHeight: '1.65', margin: 0 },
  toolList: { display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '4px' },
  toolItem: { display: 'flex', gap: '10px', alignItems: 'flex-start', fontSize: '14px', color: 'var(--text-2)', lineHeight: '1.6' },
  toolDot: {
    width: '7px', height: '7px', borderRadius: '50%',
    background: 'var(--gold)', flexShrink: 0, marginTop: '6px',
  },
  divider: { height: '1px', background: 'var(--border-2)', margin: '4px 0' },
  noteTitle: {
    fontFamily: "'Playfair Display', Georgia, serif",
    fontSize: '16px', fontWeight: '700', color: 'var(--navy)', margin: 0,
  },
  noteText: { fontSize: '14px', color: 'var(--text-2)', lineHeight: '1.65', margin: 0 },
  signature: {
    fontSize: '13px', fontWeight: '600', color: 'var(--text-3)',
    fontStyle: 'italic', marginTop: '4px',
  },
  footer: {
    borderTop: '1px solid var(--border-2)', padding: '18px 24px',
    display: 'flex', flexDirection: 'column', gap: '14px', flexShrink: 0,
    background: 'var(--bg)',
  },
  checkLabel: {
    display: 'flex', alignItems: 'flex-start', gap: '12px', cursor: 'pointer',
  },
  checkbox: {
    width: '18px', height: '18px', borderRadius: '5px', flexShrink: 0,
    border: '2px solid var(--border)', background: '#fff',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    marginTop: '1px', transition: 'all 0.15s',
  },
  checkboxChecked: { background: 'var(--navy)', borderColor: 'var(--navy)' },
  checkText: { fontSize: '13px', color: 'var(--text-2)', lineHeight: '1.55' },
  acceptBtn: {
    background: 'var(--navy)', color: '#fff', border: 'none',
    padding: '13px', borderRadius: '10px', fontSize: '15px',
    fontWeight: '700', width: '100%', fontFamily: "'DM Sans', sans-serif",
    transition: 'filter 0.15s',
  },
  spinner: {
    display: 'inline-block', width: '14px', height: '14px',
    borderRadius: '50%', border: '2px solid rgba(255,255,255,0.3)',
    borderTop: '2px solid #fff', animation: 'spin 0.7s linear infinite',
  },
};
